export default __webpack_public_path__ + "static/Plots0114-da0276925b669a311bb05d92f2bed2a0.jpg";